import { style } from 'typestyle';
import { NestedCSSSelectors } from 'typestyle/lib/types';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { imgUrl } from '~src/commonInfra/utils/ImgUrl';

export const section = style({
    overflow: 'hidden',
    margin: '0 16px',
    paddingTop: 12,
    paddingBottom: 12
});

export const sectionHeader = style({
    color: CommonStyles.Colors.NormalTextColor,
    display: 'flex',
    alignItems: 'center',
    height: 32,
});

export const focusBorder = style({
    outline: `1px solid ${CommonStyles.Colors.FocusBorderBlue}`,
    border: `1px solid transparent`,
    boxShadow: `0 0 4px 0 ${CommonStyles.Colors.FocusBorderBlue}`
});

export const sectionHeaderTitle = style({
    fontWeight: 'bold',
    fontSize: 14,
    padding: '8px 8px 0',
    display: 'block'
});

const sectionItemNest: NestedCSSSelectors = {
    '&:hover, &:focus, &:visited': {
        backgroundColor: CommonStyles.Colors.Grey245,
        color: CommonStyles.Colors.NormalTextColor,
        textDecoration: 'none',
    }
};

export const activeSectionItem = 'activeSectionItem';

sectionItemNest['&.' + activeSectionItem] = {
    backgroundColor: CommonStyles.Colors.BlueHighlight
};

export const sectionItem = style({
    color: CommonStyles.Colors.NormalTextColor,
    textDecoration: 'none',
    fontSize: 14,
    height: 32,
    $nest: sectionItemNest
});

export const sectionItemHorizontalLayout = style({
    display: 'flex',
    alignItems: 'center',
});

export const sectionItemFixedContent = style({
    flex: '0 0 auto'
});

export const sectionItemAutoFitContent = style({
    flex: '1 1 auto'
});

export const querySuggestionSection = style({
    paddingTop: '12px'
});

export const querySuggestionItem = style({
    fontSize: 14
});

export const querySuggestionItemIcon = style({
    marginRight: 8
});

export const ownerSection = style({
    paddingBottom: 2
});

export const pastQueryItemIcon = style({
    backgroundImage: imgUrl('spaces_navigation_recents.svg'),
    height: 32,
    width: 32,
    backgroundSize: '20px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
});

export const maginifierIcon = style({
    backgroundImage: imgUrl('spaces_toolbar_search_active.svg'),
    height: 32,
    width: 32,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
});

export const deleteIcon = style({
    backgroundImage: imgUrl('spaces_toolbar_delete.svg'),
    height: 32,
    width: 32,
    backgroundSize: '18px 18px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer'
});

export const contentSuggestionSection = style({
    paddingBottom: 0
});

export const contentSuggestionSectionItem = style({
    height: 'auto',
    padding: '8px',
});

export const contentSuggestionSectionItemIcon = style({
    $nest: {
        'img': {
            width: 24
        }
    }
});

export const alignCenter = style({
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
});

export const contentSuggestionSectionItemContent = style({
    marginLeft: 13,
    lineHeight: '21px',
    width: 470,
    $nest: {
        'em': {
            fontStyle: 'unset',
            fontWeight: 'bold'
        },
    }
});

export const sectionBottomBorder = style({
    borderBottom: '1px solid #e6e6e6'
});

export const useColorForHighlight = style({
    $nest: {
        'em': {
            color: CommonStyles.Colors.HyperlinkBlue
        },
        'a strong': {
            color: CommonStyles.Colors.HyperlinkBlue
        }
    }
});